import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  makeStyles,
  IconButton,
} from "@material-ui/core";
import BootstrapTable from "react-bootstrap-table-next";
import CloseIcon from "@material-ui/icons/Close"; // Import close icon
import {
  commonHeaderStyle,
  commonStyle,
  displayCommaFormatter,
  displayNullFormatter,
  rowStyle2,
} from "./../../../../Utility/utility";
import { useDispatch } from "react-redux";
import { updateAction } from "containers/gstr2a2bNewEnhancement/Reconciliation/action";

// Use makeStyles to create scoped styles
const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    display: "flex",
    justifyContent: "center", // Center the title horizontally
    alignItems: "center", // Center the title vertically
    textAlign: "center", // Ensure title text is centered
    width: "100%", // Ensure title spans the entire width of the dialog
    fontWeight: "bold", // Make title bold
    padding: "5px 0", // Optional padding for title spacing
    color: "#4f2d7f",
  },
  dialogHeader: {
    display: "flex",
    justifyContent: "center", // Place the title in the center and buttons on the right
    alignItems: "center",
    width: "100%", // Ensure header takes up full width
  },
  buttons: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
    justifyContent: "end",
    marginRight: "23px",
  },
  tableWrapper: {
    marginTop: "20px",
    marginBottom: "20px",
    position: "relative", // Set relative positioning for title positioning
    border: "0.5px solid rgba(0, 0, 0, 0.3)", // Border around the table wrapper
    borderRadius: "5px", // Rounded corners
  },
  tableBorder: {
    marginTop: "20px",
    marginBottom: "20px",
    position: "relative", // Set relative positioning for title positioning
  },
  closeButton: {
    position: "absolute",
    top: "10px",
    right: "10px",
    color: "#4f2d7f", // Change color to match your design
  },
  tableContainer: {
    marginBottom: "20px",
    // overflowX: "auto", // Horizontal scroll when the content exceeds
    border: "0.5px solid rgba(0, 0, 0, 0.3)", // Visible black border around the table
    borderRadius: "8px", // Rounded corners
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Optional: add shadow for depth
    position: "relative", // For positioning the title inside the table container
  },
  tableTitle: {
    position: "absolute",
    top: "10px", // Adjusted for better spacing from the top border
    left: "50%",
    transform: "translateX(-50%)", // Horizontally center the title
    width: "100%",
    padding: "5px 0", // Vertical padding to make the title readable
    textAlign: "center",
    // zIndex: 1,
    color: "#4f2d7f",
    fontSize: "larger",
    fontWeight: "600",
    // Ensure it appears above the table
  },
  tablesColumn: {
    display: "flex",
    alignItems: "center",
    gap: "20px", // Space between tables
    justifyContent: "center", // Center the tables horizontally in the dialog
  },
  tablesMargin: {
    marginTop: "50px", // Adjusting spacing for tables
  },
}));

const Sidewise = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [selectedPR, setSelectedPR] = useState([]);
  const [selectedRowPR, setSelectedRowPR] = useState([]);
  const [selectedGSTN, setSelectedGSTN] = useState([]);
  const [selectedRowGSTN, setSelectedRowGSTN] = useState([]);

  function handleOnSelectPR(row, isSelect) {
    if (isSelect) {
      setSelectedPR([...selectedPR, row.TXN_ID]);
      setSelectedRowPR([...selectedRowPR, row]);
    } else {
      let selected = [...selectedPR];
      selected.splice(selected.indexOf(row.TXN_ID), 1);
      setSelectedPR(selected);
      setSelectedRowPR((selectedRow) => {
        let result = selectedRow.filter((x) => x !== row);
        return result;
      });
    }
  }

  function handleOnSelectAllPR(isSelect, rows) {
    const ids = rows.map((r) => r.TXN_ID);
    if (isSelect) {
      setSelectedPR(ids);
      setSelectedRowPR(rows);
    } else {
      setSelectedPR([]);
      setSelectedRowPR([]);
    }
  }

  function handleOnSelectGSTN(row, isSelect) {
    if (isSelect) {
      setSelectedGSTN([...selectedGSTN, row.TXN_ID]);
      setSelectedRowGSTN([...selectedRowGSTN, row]);
    } else {
      let selected = [...selectedGSTN];
      selected.splice(selected.indexOf(row.TXN_ID), 1);
      setSelectedGSTN(selected);
      setSelectedRowGSTN((selectedRow) => {
        let result = selectedRow.filter((x) => x !== row);
        return result;
      });
    }
  }

  function handleOnSelectAllGSTN(isSelect, rows) {
    const ids = rows.map((r) => r.TXN_ID);
    if (isSelect) {
      setSelectedGSTN(ids);
      setSelectedRowGSTN(rows);
    } else {
      setSelectedGSTN([]);
      setSelectedRowGSTN([]);
    }
  }

  const selectRowPR = {
    mode: "checkbox",
    selected: selectedPR,
    onSelect: handleOnSelectPR,
    onSelectAll: handleOnSelectAllPR,
    headerColumnStyle: {
      width: "37px",
      verticalAlign: "text-top",
    },
    selectColumnStyle: {
      width: "37px",
      textAlign: "center",
    },
  };

  const selectRowGSTN = {
    mode: "checkbox",
    selected: selectedGSTN,
    onSelect: handleOnSelectGSTN,
    onSelectAll: handleOnSelectAllGSTN,
    headerColumnStyle: {
      width: "37px",
      verticalAlign: "text-top",
    },
    selectColumnStyle: {
      width: "37px",
      textAlign: "center",
    },
  };

  // Table columns and data
  const columnsGstn = [
    {
      dataField: "GSTIN_PURCHASE",
      text: "Recipient GSTIN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "16%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "GSTIN_PURCHASE"),
    },
    {
      dataField: "CTIN_PURCHASE",
      text: "Supplier GSTIN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "16%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "CTIN_PURCHASE"),
    },
    {
      dataField: "INUM_PURCHASE",
      text: "Document Number",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "16%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "INUM_PURCHASE"),
    },
    {
      dataField: "IDT_PURCHASE",
      text: "Document Date",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "16%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "IDT_PURCHASE"),
    },

    {
      dataField: "TXVAL_PURCHASE",
      text: "Taxable Value",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "16%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "TXVAL_PURCHASE"),
    },
    {
      dataField: "TOTAL_GST",
      text: "GST Amount",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "16%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "TOTAL_GST"),
    },
  ];

  const columnsPR = [
    {
      dataField: "GSTIN",
      text: "Recipient GSTIN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "16%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "GSTIN"),
    },
    {
      dataField: "CTIN_SALE",
      text: "Supplier GSTIN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "16%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "CTIN_SALE"),
    },
    {
      dataField: "INUM_SALE",
      text: "Document Number",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "16%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "INUM_SALE"),
    },
    {
      dataField: "IDT_SALE",
      text: "Document Date",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "16%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "IDT_SALE"),
    },

    {
      dataField: "TXVAL_SALE",
      text: "Taxable Value",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "16%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "TXVAL_SALE"),
    },
    {
      dataField: "TOTAL_GST",
      text: "GST Amount",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "16%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "TOTAL_GST"),
    },
  ];

  const handleAction = async (type) => {
    try {
      await dispatch(updateAction(type, selectedRowPR, selectedRowGSTN));
      props.handleSidewiseClose();
    } catch (error) {
      console.log("Error in handleAction:", error);
    }
  };

  useEffect(() => {
    return () => {
      setSelectedGSTN([]);
      setSelectedPR([]);
      setSelectedRowGSTN([]);
      setSelectedRowPR([]);
    };
  }, []);

  return (
    <Dialog open={props.open} onClose={false} fullWidth={true} maxWidth="lg">
      <DialogTitle className={classes.dialogHeader}>
        <div className={classes.dialogTitle}>Sidewise Match</div>
        <IconButton
          className={classes.closeButton}
          onClick={props.handleSidewiseClose}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <div className={classes.buttons}>
        <Button
          onClick={() => handleAction("ACCEPT PR")}
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            textTransform: "capitalize",
            fontSize: "12px",
          }}
        >
          Accept PR
        </Button>
        <Button
          onClick={() => handleAction("ACCEPT GSTN")}
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            textTransform: "capitalize",
            fontSize: "12px",
          }}
        >
          Accept GSTN
        </Button>
        {/* <Button
          onClick={() => handleAction("REJECT")}
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            textTransform: "capitalize",
            fontSize: "12px",
          }}
        >
          Reject GSTN
        </Button> */}
        {/* <Button
          onClick={props.handleReset}
          variant="contained"
          color="primary"
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            textTransform: "capitalize",
            fontSize: "12px",
          }}
        >
          Reset
        </Button> */}
      </div>
      <DialogContent style={{ paddingTop: 20 }}>
        <div className={classes.tablesColumn}>
          {/* First Table */}
          <div className={classes.tableContainer}>
            <div className={classes.tableTitle}>Missing in PR</div>
            <div
              className="light-border-gstr2a2bnew-table"
              style={{ overflow: "auto" }}
            >
              <div
                style={{ width: "200%", overflowY: "scroll", height: "20em" }}
              >
                <BootstrapTable
                  keyField="TXN_ID"
                  data={props.prData}
                  columns={columnsPR}
                  rowStyle={rowStyle2}
                  wrapperClasses={`${classes.tableBorder} ${classes.tablesMargin}`}
                  selectRow={selectRowPR}
                />
              </div>
            </div>
          </div>
          {/* Second Table */}
          <div className={classes.tableContainer}>
            <div className={classes.tableTitle}>Missing in GSTN</div>
            <div
              className="light-border-gstr2a2bnew-table"
              style={{ overflow: "auto" }}
            >
              <div
                style={{ width: "200%", overflowY: "scroll", height: "20em" }}
              >
                <BootstrapTable
                  keyField="TXN_ID"
                  data={props.gstnData}
                  columns={columnsGstn}
                  rowStyle={rowStyle2}
                  wrapperClasses={`${classes.tableBorder} ${classes.tablesMargin}`}
                  selectRow={selectRowGSTN}
                />
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default Sidewise;
